import { InstallProvider } from '../features/install/InstallContext.js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { adminQueryDefaults } from '../lib/query-client.js';
import { AdminApiProvider } from './AdminApiContext.js';
import { AdminRouter } from './Router.js';

const router = createBrowserRouter([{ path: '*', element: <AdminRouter /> }]);

const queryClient = new QueryClient({ defaultOptions: adminQueryDefaults });

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AdminApiProvider>
        <InstallProvider>
          <RouterProvider router={router} />
        </InstallProvider>
      </AdminApiProvider>
    </QueryClientProvider>
  );
}
